// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"03f3d9b8","453":"195627e6","455":"987928b6","977":"03d43f92"}[chunkId] + ".chunk.js";
};